// BV-1681 / BV-2304: keep the UTM landing URL ("last click") so sign-up can send it as `registerURL`
// even when the URL changes before the customer registers (e.g. `/?register=true`, terms page, in-site navigation).

export const UTM_LANDING_URL_STORAGE_KEY = 'bm_utm_landing_url';

const UTM_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];

const isBrowser = () => typeof window !== 'undefined';

// true when the query string has at least one non-empty utm_* param
const hasUtmParams = (search) => {
  const searchParams = new URLSearchParams(search || '');
  return UTM_PARAMS.some((key) => !!searchParams.get(key));
};

// `?utm_...` built from the non-empty utm_* params of a Next.js `ctx.query` (server-safe), '' when none.
// Used to keep UTM when the guest root page redirects to the guest home page.
export const getUtmQueryString = (query = {}) => {
  const searchParams = new URLSearchParams();
  UTM_PARAMS.forEach((key) => {
    const value = Array.isArray(query[key]) ? query[key][0] : query[key];
    if (value) searchParams.set(key, value);
  });
  const queryString = searchParams.toString();
  return queryString ? `?${queryString}` : '';
};

// Store the current URL when it carries UTM params; always overwrite (last click wins).
export const captureUtmLandingURL = () => {
  if (!isBrowser()) return;
  try {
    if (hasUtmParams(window.location.search)) {
      window.sessionStorage.setItem(UTM_LANDING_URL_STORAGE_KEY, window.location.href);
    }
  } catch (error) {
    // sessionStorage unavailable (private mode, blocked storage): ignore
  }
};

// URL to send as `registerURL`: current URL if it has UTM, else the stored UTM landing URL, else the current URL.
export const getRegisterURL = () => {
  if (!isBrowser()) return '';
  const currentURL = window.location.href;
  try {
    if (hasUtmParams(window.location.search)) return currentURL;
    return window.sessionStorage.getItem(UTM_LANDING_URL_STORAGE_KEY) || currentURL;
  } catch (error) {
    return currentURL;
  }
};

export default {
  captureUtmLandingURL,
  getRegisterURL,
  getUtmQueryString,
};
